import { writeUrlState } from "./accessoryUrlState";

export const ACCESSORIES_PATH = "/accessories";

export const accessoriesPath = (state) => {
  const params = writeUrlState(state || {}).toString();

  return params ? `${ACCESSORIES_PATH}?${params}` : ACCESSORIES_PATH;
};

export const accessoryPath = ({ productId, coordinates }) => {
  const params = new URLSearchParams();

  if (Number.isFinite(coordinates?.latitude)) {
    params.set("lat", String(coordinates.latitude));
    params.set("lng", String(coordinates.longitude));
  }

  const query = params.toString();

  return `${ACCESSORIES_PATH}/${productId}${query ? `?${query}` : ""}`;
};
